import { useState, useEffect } from "react";
import { flushSync } from "react-dom";

interface UsePrintReturn {
  isPrint: boolean;
  print: () => void;
}

const usePrint = (): UsePrintReturn => {
  const [isPrint, setIsPrint] = useState(false);

  function print(): void {
    flushSync(() => {
      setIsPrint(true);
      window.print();
    });
  }

  useEffect(() => {
    const beforePrint = (): void => {
      flushSync(() => {
        setIsPrint(true);
      });
    };
    const afterPrint = (): void => {
      flushSync(() => {
        setIsPrint(false);
      });
    };

    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia("print");
      const handleMediaChange = (event: MediaQueryListEvent): void => {
        event.preventDefault();
        if (event.matches) {
          beforePrint();
        } else {
          afterPrint();
        }
      };

      try {
        mediaQueryList.addEventListener("change", handleMediaChange);
      } catch (error) {
        try {
          mediaQueryList.addListener(handleMediaChange);
        } catch (error) {
          console.debug("Error", error);
        }
      }

      setIsPrint(mediaQueryList.matches);

      return () => {
        try {
          mediaQueryList.removeEventListener("change", handleMediaChange);
        } catch (error) {
          try {
            mediaQueryList.removeListener(handleMediaChange);
          } catch (error) {
            console.debug("Error", error);
          }
        }
      };
    }

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;

    return () => {
      window.onbeforeprint = null;
      window.onafterprint = null;
    };
  }, [setIsPrint]);

  return { isPrint, print };
};

export { usePrint };
